// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsie-takeaway-point-editor-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: snow;
  padding: 5px;
  flex: 1 1;
}

@media (max-width: 500px) {
  .newsie-takeaway-point-editor-container {
    font-size: small;
  }
}

.newsie-takeaway-words-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: snow;
  padding: 5px;
  flex: 1 1;
}

.newsie-takeaway-word {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(88, 144, 181);
  padding: 5px;
  flex: 1 1;
  margin: 5px;
}

.newsie-takeaway-point-delete-button-container {
  display: flex;
  flex: 1 1;
  width: 100%;
  justify-content: flex-end;
  margin-left: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.newsie-takeway-point-delete-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(224, 48, 83, 0.712);
  color: white;
  /* font-size: larger; */
  font-weight: bold;
  border-radius: 5px;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/NewsieTakeawayPoint/NewsieTakeawayPoint.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".newsie-takeaway-point-editor-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: snow;\n  padding: 5px;\n  flex: 1;\n}\n\n@media (max-width: 500px) {\n  .newsie-takeaway-point-editor-container {\n    font-size: small;\n  }\n}\n\n.newsie-takeaway-words-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: snow;\n  padding: 5px;\n  flex: 1;\n}\n\n.newsie-takeaway-word {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(88, 144, 181);\n  padding: 5px;\n  flex: 1;\n  margin: 5px;\n}\n\n.newsie-takeaway-point-delete-button-container {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  justify-content: flex-end;\n  margin-left: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.newsie-takeway-point-delete-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(224, 48, 83, 0.712);\n  color: white;\n  /* font-size: larger; */\n  font-weight: bold;\n  border-radius: 5px;\n  padding: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
